import React from 'react'
import Radium from 'radium'
import NumberFormat from 'react-number-format'
import colors from '../../theme/colors'
import borderRadius from '../../theme/borderRadius'

import Width from '../Width'

const colorfulInputStyle = (value) => {
  if (value > 0) return styles.colorful.positive
  if (value < 0) return styles.colorful.negative

  return {}
}

const inputStyle = ({ isSmall, disabled, bold, colorful, value }) => ({
  ...styles.field,
  ...(isSmall ? styles.small.field : {}),
  ...(disabled ? styles.disabled.field : {}),
  ...(bold ? styles.bold.field : {}),
  ...(colorful ? colorfulInputStyle(value) : {})
})

export default Radium(({
  disabled,
  onChange,
  onClick,
  bold,
  colorful,
  value,
  ...props,
}) => (
  <div
    style={styles.container}
    onClick={onClick}
  >
    <div style={styles.prefix}>
      $
    </div>
    <Width>
      {({ isSmall }) => (
        <NumberFormat
          type='text'
          style={inputStyle({ disabled, isSmall, bold, colorful, value })}
          thousandSeparator
          value={value}
          onValueChange={({ value }) => (
            onChange({
              target: {
                name: props.name,
                value,
              }
            })
          )}
          {...props}
        />
      )}
    </Width>
  </div>
))

const styles = {
  container: {
    display: 'flex',
    height: '34px'
  },
  prefix: {
    padding: '0 14px',
    backgroundColor: colors.lightGrey,
    color: colors.darkGrey,
    borderRadius: `${borderRadius} 0 0 ${borderRadius}`,
    display: 'flex',
    alignItems: 'center',
  },
  field: {
    width: '80px',
    borderRadius: `0 ${borderRadius} ${borderRadius} 0`,
    border: `1px solid ${colors.lightGrey}`,
    padding: '0 10px',
    fontSize: '14px',
  },
  disabled: {
    field: {
      backgroundColor: colors.lightLightGrey,
      color: colors.midGrey,
      cursor: 'pointer',
    },
  },
  small: {
    field: {
      width: '60px',
      padding: '0 5px',
    },
  },
  bold: {
    field: {
      fontWeight: 600,
    },
  },
  colorful: {
    positive: {
      color: colors.green,
    },
    negative: {
      color: colors.reddish,
    },
  },
}
